import * as Yup from 'yup';
import { UnitedStatesCountryCode } from '../../pages/arc/constants/constant-strings';
import { RegularExpressions } from '../constants/regular-expressions';
import { getRequiredText } from '../helpers/transformer';
import { LabelSettingProps } from '../models/epi-model';
import { PersonPhoneValues } from '../models/person-model';

export function phoneNumberValidationBasedOnCountryCode(phoneType: string = '') {
    const validationMessage = phoneType.length > 0 ? `Invalid ${phoneType} Phone Number` : 'Invalid Phone Number';

    return {
        is: value => value !== UnitedStatesCountryCode,
        then: Yup.string().matches(RegularExpressions.InternationalPhone, validationMessage),
        otherwise: Yup.string().matches(RegularExpressions.USPhone, validationMessage),
    };
}

export const PhoneValidationSchema = (
    phoneRequiredMessage: string,
    phoneCountryCodeValue: string,
    phoneType: string = '',
    required: boolean = false,
    ) => {
    
        const validationMessage = phoneType.length > 0 ? `Invalid ${phoneType} Phone Number` : 'Invalid Phone Number';

        if (!phoneCountryCodeValue && !required){
            return Yup.string().nullable();
        }

        if (phoneCountryCodeValue === UnitedStatesCountryCode){
            return Yup.string().required(phoneRequiredMessage).matches(RegularExpressions.USPhone, validationMessage);
        }

        return Yup.string().required(phoneRequiredMessage).matches(RegularExpressions.InternationalPhone, validationMessage);
};

export const PhoneCountryCodeValidationSchema = (
    phoneCountryCodeRequiredMessage: string,
    phoneValue: string,    
    required: boolean = false,
    ) => {
        if (phoneValue || required){
            return Yup.string().nullable().required(phoneCountryCodeRequiredMessage);
        }
        
        return Yup.string().nullable();
};

export const PersonPhoneValidationSchema = (
    labelSetting: LabelSettingProps,
    personPhoneValues?: PersonPhoneValues) => {

    return {
        business_phone_formated: PhoneValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.businessPhoneLabel),
            personPhoneValues?.business_phone_country_code,
            'business'),
        business_phone_country_code: PhoneCountryCodeValidationSchema(
                getRequiredText(labelSetting.requiredFormat, labelSetting.businessPhoneLabel),
                personPhoneValues?.business_phone_formated),
        home_phone_formated: PhoneValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.homePhoneLabel),
            personPhoneValues?.home_phone_country_code,
            'home'),
        home_phone_country_code: PhoneCountryCodeValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.homePhoneLabel),
            personPhoneValues?.home_phone_formated),
        mobile_phone_formated: PhoneValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.cellPhoneLabel),
            personPhoneValues?.mobile_phone_country_code,
            'mobile'),
        mobile_phone_country_code: PhoneCountryCodeValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.cellPhoneLabel),
            personPhoneValues?.mobile_phone_formated),
    };
};

export const InstitutionPhoneValidationSchema = (
    labelSetting: LabelSettingProps, 
    business_phone_formatted,
    business_phone_country_code,
    fax_phone_formatted,
    fax_phone_country_code  ) => {
        const required = true;
    return {
        business_phone_formatted: PhoneValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.businessPhoneLabel),
            business_phone_country_code,
            'Business',
            required),
        business_phone_country_code: PhoneCountryCodeValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.businessPhoneLabel),
            business_phone_formatted,
            required),

        fax_phone_formatted: PhoneValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.faxPhone),
            fax_phone_country_code,
            'Fax'),
        fax_phone_country_code: PhoneCountryCodeValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.faxPhone),
            fax_phone_formatted),        
    };
};

export const InstitutionAddRequestPhoneValidationSchema =  (
    labelSetting: LabelSettingProps, 
    office_phone_formatted,
    office_country_code,
    fax_formatted,
    fax_country_code  ) => {
        const required = true;
    return {
        office_phone_formatted: PhoneValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.businessPhoneLabel),
            office_country_code,
            'Business',
            required),
        office_country_code: PhoneCountryCodeValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.businessPhoneLabel),
            office_phone_formatted,
            required),

        fax_phone_formatted: PhoneValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.faxPhone),
            fax_country_code,
            'Fax'),
        fax_country_code: PhoneCountryCodeValidationSchema(
            getRequiredText(labelSetting.requiredFormat, labelSetting.faxPhone),
            fax_formatted),        
    };
};

